// Години роботи сайту за київським часом, 11:00–22:00: стан у шапці й подяка в кошику після замовлення
export const OPEN_FROM = 11 * 60;
export const OPEN_TO = 22 * 60;

export function kyivMinutes(date = new Date()) {
    const parts = new Intl.DateTimeFormat('uk-UA', { timeZone: 'Europe/Kyiv', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(date);
    return +parts.find(part => part.type == 'hour').value * 60 + +parts.find(part => part.type == 'minute').value;
}

// closed — $store.state.closed (вимикачі з адмінки); без нього — лише години
export function isOpenNow(closed, date) {
    const minutes = kyivMinutes(date);
    return !(closed && closed.all) && minutes >= OPEN_FROM && minutes < OPEN_TO;
}

// 660 → «11:00»
export function hhmm(minutes) {
    return String(Math.floor(minutes / 60)).padStart(2, '0') + ':' + String(minutes % 60).padStart(2, '0');
}

// Слоти доставки, як у бекенді (OrderController::DELIVERY_WORK_TIME, /order/delivery-time):
// з 12:00, останній 21:20–21:40, крок 20 хв
export const SLOT_FROM = 12 * 60;
export const SLOT_LAST = 21 * 60 + 20;
export const SLOT_STEP = 20;

// Київський годинник у мілісекундах «як UTC» — щоб порахувати зсув від UTC (2 чи 3 год)
function kyivWall(ms) {
    const parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Kyiv', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date(ms)).forEach(part => { parts[part.type] = +part.value; });
    return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute);
}

// Слоти на завтра за київським часом — у тому ж вигляді, що /order/delivery-time ({ value: unix-секунди, start, end }).
// Бекенд приймає будь-який delivery_at, а касир у /v2 показує дату, коли вона не сьогоднішня
export function tomorrowSlots(now = new Date()) {
    const today = new Date(kyivWall(now.getTime()));
    const day = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() + 1);
    const slots = [];
    for (let minutes = SLOT_FROM; minutes <= SLOT_LAST; minutes += SLOT_STEP) {
        const wall = day + minutes * 60000;
        slots.push({ value: Math.round((wall - (kyivWall(wall) - wall)) / 1000), start: hhmm(minutes), end: hhmm(minutes + SLOT_STEP) });
    }
    return slots;
}
